import { ref } from 'joi';
import React, { useEffect, useState, useRef, useContext } from 'react'
import { BackIcon, CloseIcon } from '../../../icons';
import { useHistory } from 'react-router-dom'
import { AuthContext } from '../../../context/AuthContext'
import { signInWithPopup } from "firebase/auth";
import { userService } from '../../../services';


export default function EmailVerification({ open, onClose, back }) {

    const { setUser,signup,setAccessToken,startSilentRefresh} = useContext(AuthContext)
    const input1 = useRef();
    const input2 = useRef();
    const input3 = useRef();
    const input4 = useRef();
    const [opt1, setOtp1] = useState(null);
    const [otp2, setOtp2] = useState(null);
    const [otp3, setOtp3] = useState(null);
    const [opt4, setOtp4] = useState(null);

    // const otp = { 'otp1': null, 'otp2': null, 'otp3': null, 'otp4': null }
    const [openMenu, setOpenMenu] = useState(open);
    useEffect(() => {
        setOpenMenu(open)

    }, [open]);
    const handleClose = () => {
        setOpenMenu(false)
        onClose(true)
    }
    const [userData, setUserData] = useState({})

    const history = useHistory()
    // let first_name, last_name, userId
    let user_id;


    const onSubmit = (user) => {

        let sendData = {
            user_id: signup.user_id,
            otp:  opt1 + otp2 +otp3 +opt4 ,
        }
        userService.verifyGmailOTP(sendData).then((response) => {

            setUser(response.data.user)
            setAccessToken(response.data.token)
            startSilentRefresh()
            handleClose()
            history.push(`/app/dashboard`)
        })
    }




    return (
        <div className='form__container'>


            <div className={openMenu ? 'overlay block' : 'hidden'} ></div>
            <div className={openMenu ? 'singup__screen signup_open' : 'singup__screen'}>
                <div className='signup__header flex justify-between items-center'>
                    <h4 className='font-semibold text-gray-700 signup__title'>
                        <BackIcon onClick={back} style={{ marginRight: '10px', display: 'inline' }} />
                        Email Verification</h4>
                    <CloseIcon className='close_icon' onClick={handleClose} />
                </div>
                <div className='email_container'>
                    <p className='mt-5'>We just sent an OTP to your email address. Please enter it below to verify your email.</p>
                    <h5 className='mt-5 font-semibold'>Enter OTP sent to your email</h5>
                </div>
                <div className='flex otp_input'>
                    <div className='input_container'>
                        <input className='casting_input' ref={input1} name='otp'
                            onChange={(e) => {
                                setOtp1(e.target.value)
                                 input2.current && input2.current.focus() }}
                        ></input>
                    </div>
                    <div className='input_container'>
                        <input className='casting_input' ref={input2} name='otp'
                            onChange={(e) => { 
                                setOtp2(e.target.value)
                                input3.current && input3.current.focus() }}
                        ></input>
                    </div>
                    <div className='input_container'>
                        <input className='casting_input' ref={input3} name='otp'
                            onChange={(e) => { 
                                setOtp3(e.target.value)
                                input4.current && input4.current.focus() }}
                        ></input>
                    </div>
                    <div className='input_container'>
                        <input className='casting_input' ref={input4} name='otp'
                            onChange={(e) => {  setOtp4(e.target.value)}}
                        ></input>
                    </div>
                </div>
                <button type='submit' className="casting_btn primary-bg font-medium " onClick={(e) => { e.preventDefault(); onSubmit() }}>
                    verify</button>
            </div>

        </div>
    )
}
